import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TextContentService } from '@core/text-content/text-content.service';
import { FlightTrackerFacade } from '@store/flight-tracker/flight-tracker.facade';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { FlightTrackerMessages } from './flight-tracker.type';
import { FlightTrackerCopy } from './types/flight-tracker-copy.type';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-flight-tracker',
  templateUrl: './flight-tracker.component.html',
  styleUrls: ['./flight-tracker.component.scss'],
})
export class FlightTrackerComponent implements OnInit {
  private _destroy = inject(DestroyRef);

  messages: FlightTrackerMessages;
  flightTrackerText$: Observable<FlightTrackerCopy>;

  constructor(
    private textContentService: TextContentService,
    private flightTrackerFacade: FlightTrackerFacade,
  ) {}

  ngOnInit() {
    this.flightTrackerText$ = this.textContentService
      .getJsonAsset('flight-tracker')
      .pipe(
        tap(copy => this.flightTrackerFacade.setFlightTrackerResponse(copy)),
        takeUntilDestroyed(this._destroy),
      );

    this.textContentService
      .getJsonAsset('booker-response-text')
      .pipe(takeUntilDestroyed(this._destroy))
      .subscribe(copy => {
        this.flightTrackerFacade.setBookerResponse(copy);
      });
  }
}

export const flightTrackerResolver = (registry, data) => ({
  messages: {
    noResults: data.noResults?.length > 0 ? data.noResults[0] : {},
    serviceError: data.serviceError?.length > 0 ? data.serviceError[0] : {},
  },
});
